module.exports = __webpack_public_path__ + "img/4bf26cc.png";